// extracted by mini-css-extract-plugin
export default {"Badge":"IndicatorBadges_Badge__RGlVA","infoIcon":"IndicatorBadges_infoIcon__lc8Lc","noButton":"IndicatorBadges_noButton__3wDh9","infoBadge":"IndicatorBadges_infoBadge__sgpkZ"};